import { createSlice } from "@reduxjs/toolkit";
import {
  AddCultureAction,
  DeleteCultureAction,
  GetAllCultureAction,
  UpdateCultureAction,
} from "store/middlewares/dataManagement/culture";

// isDeleteMeFulFilled
export const cultureSlice = createSlice({
  name: "culture",
  initialState: {
    cultureLoading: true,
    culture: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllCultureAction.pending, (state) => {
        // state.cultureLoading = true;
        // state.culture = null;
        state.culture = state.culture?.data?.length > 0 ? state.culture : null;
      })
      .addCase(GetAllCultureAction.fulfilled, (state, action) => {
        state.cultureLoading = false;
        state.culture = action.payload.response;
      })
      .addCase(GetAllCultureAction.rejected, (state) => {
        state.cultureLoading = false;
        state.culture = null;
      })
      // Delete
      .addCase(DeleteCultureAction.fulfilled, (state, action) => {
        // state.cultureLoading = false;
        // state.culture = {
        //   ...state.culture,
        //   total: Number(state.culture.total) - 1,
        //   data: state.culture?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.cultureLoading = false;
        state.culture = action.payload.response;
      })
      //Update
      .addCase(UpdateCultureAction.fulfilled, (state, action) => {
        state.cultureLoading = false;
        state.culture = {
          ...state.culture,
          data: state.culture.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddCultureAction.fulfilled, (state, action) => {
        // state.cultureLoading = false;
        // state.culture = {
        //   ...state.culture,
        //   total: Number(state.culture.total) + 1,
        //   data: [action.payload.response, ...state.culture.data],
        // };
        state.cultureLoading = false;
        state.culture = action.payload.response;
      });
  },
});

export default cultureSlice.reducer;
